import React from "react";

export function CopyIconComponent() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.175 2.625H1.575C0.912258 2.625 0.375 3.16226 0.375 3.825V10.425C0.375 11.0877 0.912258 11.625 1.575 11.625H8.175C8.83774 11.625 9.375 11.0877 9.375 10.425V3.825C9.375 3.16226 8.83774 2.625 8.175 2.625Z"
        fill="#4E84A2"
      />
      <path
        d="M10.425 0.375H3.825C3.50704 0.375989 3.20239 0.502735 2.97756 0.727564C2.75273 0.952394 2.62599 1.25704 2.625 1.575V2.25H8.44875C8.79356 2.25099 9.12396 2.3884 9.36778 2.63222C9.6116 2.87604 9.74901 3.20644 9.75 3.55125V9.375H10.425C10.743 9.37401 11.0476 9.24727 11.2724 9.02244C11.4973 8.79761 11.624 8.49296 11.625 8.175V1.575C11.624 1.25704 11.4973 0.952394 11.2724 0.727564C11.0476 0.502735 10.743 0.375989 10.425 0.375V0.375Z"
        fill="#4E84A2"
      />
    </svg>
  );
}

export function WhiteCopyIconComponent() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.175 2.625H1.575C0.912258 2.625 0.375 3.16226 0.375 3.825V10.425C0.375 11.0877 0.912258 11.625 1.575 11.625H8.175C8.83774 11.625 9.375 11.0877 9.375 10.425V3.825C9.375 3.16226 8.83774 2.625 8.175 2.625Z"
        fill="#FFFFFF"
      />
      <path
        d="M10.425 0.375H3.825C3.50704 0.375989 3.20239 0.502735 2.97756 0.727564C2.75273 0.952394 2.62599 1.25704 2.625 1.575V2.25H8.44875C8.79356 2.25099 9.12396 2.3884 9.36778 2.63222C9.6116 2.87604 9.74901 3.20644 9.75 3.55125V9.375H10.425C10.743 9.37401 11.0476 9.24727 11.2724 9.02244C11.4973 8.79761 11.624 8.49296 11.625 8.175V1.575C11.624 1.25704 11.4973 0.952394 11.2724 0.727564C11.0476 0.502735 10.743 0.375989 10.425 0.375V0.375Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export function ExternalLinkIconComponent() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 7.21334C11.8231 7.21334 11.6535 7.28358 11.5285 7.40861C11.4035 7.53363 11.3333 7.7032 11.3333 7.88001V12.6667C11.3333 12.8435 11.263 13.0131 11.138 13.1381C11.013 13.2631 10.8434 13.3333 10.6666 13.3333H3.33325C3.15644 13.3333 2.98687 13.2631 2.86185 13.1381C2.73682 13.0131 2.66659 12.8435 2.66659 12.6667V5.33334C2.66659 5.15653 2.73682 4.98696 2.86185 4.86194C2.98687 4.73691 3.15644 4.66668 3.33325 4.66668H8.11992C8.29673 4.66668 8.4663 4.59644 8.59132 4.47141C8.71635 4.34639 8.78659 4.17682 8.78659 4.00001C8.78659 3.8232 8.71635 3.65363 8.59132 3.52861C8.4663 3.40358 8.29673 3.33334 8.11992 3.33334H3.33325C2.80282 3.33334 2.29411 3.54406 1.91904 3.91913C1.54397 4.2942 1.33325 4.80291 1.33325 5.33334V12.6667C1.33325 13.1971 1.54397 13.7058 1.91904 14.0809C2.29411 14.456 2.80282 14.6667 3.33325 14.6667H10.6666C11.197 14.6667 11.7057 14.456 12.0808 14.0809C12.4559 13.7058 12.6666 13.1971 12.6666 12.6667V7.88001C12.6666 7.7032 12.5963 7.53363 12.4713 7.40861C12.3463 7.28358 12.1767 7.21334 11.9999 7.21334ZM14.6133 1.74668C14.5456 1.58378 14.4162 1.45433 14.2533 1.38668C14.1731 1.35252 14.087 1.3344 13.9999 1.33334H9.99992C9.82311 1.33334 9.65354 1.40358 9.52851 1.52861C9.40349 1.65363 9.33325 1.8232 9.33325 2.00001C9.33325 2.17682 9.40349 2.34639 9.52851 2.47141C9.65354 2.59644 9.82311 2.66668 9.99992 2.66668H12.3933L5.52659 9.52668C5.4641 9.58865 5.4145 9.66239 5.38066 9.74363C5.34681 9.82486 5.32939 9.912 5.32939 10C5.32939 10.088 5.34681 10.1752 5.38066 10.2564C5.4145 10.3376 5.4641 10.4114 5.52659 10.4733C5.58856 10.5358 5.66229 10.5854 5.74353 10.6193C5.82477 10.6531 5.91191 10.6705 5.99992 10.6705C6.08793 10.6705 6.17506 10.6531 6.2563 10.6193C6.33754 10.5854 6.41128 10.5358 6.47325 10.4733L13.3333 3.60668V6.00001C13.3333 6.17682 13.4035 6.34639 13.5285 6.47141C13.6535 6.59644 13.8231 6.66668 13.9999 6.66668C14.1767 6.66668 14.3463 6.59644 14.4713 6.47141C14.5963 6.34639 14.6666 6.17682 14.6666 6.00001V2.00001C14.6655 1.91289 14.6474 1.82682 14.6133 1.74668V1.74668Z"
        fill="#5DC2FA"
      />
    </svg>
  );
}

export function PersonIconComponent() {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00001 7.16667C6.65928 7.16667 7.30374 6.97117 7.85191 6.6049C8.40007 6.23863 8.82731 5.71803 9.0796 5.10895C9.3319 4.49986 9.39791 3.82964 9.26929 3.18303C9.14067 2.53643 8.8232 1.94249 8.35703 1.47631C7.89085 1.01014 7.29691 0.692668 6.65031 0.564051C6.0037 0.435433 5.33348 0.501444 4.72439 0.753736C4.11531 1.00603 3.59471 1.43327 3.22844 1.98143C2.86217 2.5296 2.66667 3.17406 2.66667 3.83334C2.66667 4.71739 3.01786 5.56524 3.64298 6.19036C4.2681 6.81548 5.11595 7.16667 6.00001 7.16667ZM11 15.5C11.221 15.5 11.433 15.4122 11.5893 15.2559C11.7455 15.0996 11.8333 14.8877 11.8333 14.6667C11.8333 13.1196 11.2188 11.6358 10.1248 10.5419C9.03083 9.44792 7.5471 8.83333 6.00001 8.83333C4.45291 8.83333 2.96918 9.44792 1.87522 10.5419C0.781253 11.6358 0.166672 13.1196 0.166672 14.6667C0.166672 14.8877 0.254469 15.0996 0.41075 15.2559C0.56703 15.4122 0.778991 15.5 1.00001 15.5H11Z"
        fill="#222222"
      />
    </svg>
  );
}

export function NewCopyIconComponent() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_257_3051)">
        <path
          d="M10.9 3.5H2.1C1.21634 3.5 0.5 4.21634 0.5 5.1V13.9C0.5 14.7837 1.21634 15.5 2.1 15.5H10.9C11.7837 15.5 12.5 14.7837 12.5 13.9V5.1C12.5 4.21634 11.7837 3.5 10.9 3.5Z"
          fill="#4E84A1"
        />
        <path
          d="M13.9 0.5H5.1C4.67606 0.501319 4.26986 0.670313 3.97009 0.970086C3.67031 1.26986 3.50132 1.67606 3.5 2.1V3H11.265C11.7247 3.00132 12.1653 3.18454 12.4904 3.50963C12.8155 3.83472 12.9987 4.27526 13 4.735V12.5H13.9C14.3239 12.4987 14.7301 12.3297 15.0299 12.0299C15.3297 11.7301 15.4987 11.3239 15.5 10.9V2.1C15.4987 1.67606 15.3297 1.26986 15.0299 0.970086C14.7301 0.670313 14.3239 0.501319 13.9 0.5Z"
          fill="#4E84A1"
        />
      </g>
      <defs>
        <clipPath id="clip0_257_3051">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EditIconComponent() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_257_3046)">
        <path
          d="M13.3548 0.46998C13.0598 0.174965 12.5898 0.174965 12.2948 0.46998L6.59984 6.16496C6.50985 6.24998 6.44985 6.35996 6.40984 6.47996L5.47985 9.58497C5.39983 9.84998 5.47484 10.135 5.66985 10.33C5.80983 10.475 6.00484 10.55 6.19985 10.55C6.26982 10.55 6.34484 10.54 6.41484 10.52L9.51982 9.58997C9.63985 9.54996 9.74983 9.48997 9.83482 9.39997L15.5298 3.70496C15.6699 3.56498 15.7498 3.37498 15.7498 3.17497C15.7498 2.97499 15.6699 2.78498 15.5298 2.64497L13.3548 0.46998Z"
          fill="#4E84A1"
        />
        <path
          d="M15 7.25C14.5857 7.25 14.25 7.58594 14.25 8V13C14.25 13.6895 13.6892 14.25 13 14.25H3C2.31079 14.25 1.75 13.6895 1.75 13V3C1.75 2.31054 2.31079 1.75 3 1.75H8C8.4143 1.75 8.75 1.41406 8.75 1C8.75 0.58594 8.4143 0.25 8 0.25H3C1.48364 0.25 0.25 1.48389 0.25 3V13C0.25 14.5161 1.48364 15.75 3 15.75H13C14.5164 15.75 15.75 14.5161 15.75 13V8C15.75 7.58594 15.4143 7.25 15 7.25Z"
          fill="#4E84A1"
        />
      </g>
      <defs>
        <clipPath id="clip0_257_3046">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DeleteIconComponent() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6128 1.66446H8.75553C8.75553 1.22302 8.57054 0.799658 8.24125 0.48751C7.91196 0.175362 7.46536 0 6.99967 0C6.53399 0 6.08739 0.175362 5.7581 0.48751C5.42881 0.799658 5.24382 1.22302 5.24382 1.66446H1.38652C1.10711 1.66446 0.839146 1.76968 0.641574 1.95697C0.444002 2.14426 0.333008 2.39828 0.333008 2.66314C0.333008 2.92801 0.444002 3.18203 0.641574 3.36932C0.839146 3.5566 1.10711 3.66182 1.38652 3.66182L1.98295 14.4148C2.00441 14.8414 2.19807 15.2439 2.52386 15.539C2.84966 15.8341 3.28264 15.9991 3.73323 16H10.2494C10.7 15.9991 11.133 15.8341 11.4588 15.539C11.7846 15.2439 11.9782 14.8414 11.9997 14.4148L12.6128 3.68296C12.8922 3.68296 13.1602 3.57774 13.3578 3.39045C13.5553 3.20316 13.6663 2.94915 13.6663 2.68428C13.6663 2.41941 13.5553 2.1654 13.3578 1.97811C13.1602 1.79082 12.8922 1.6856 12.6128 1.6856V1.66446ZM5.92387 12.6394C5.92387 12.8159 5.84987 12.9853 5.71816 13.1101C5.58644 13.235 5.4078 13.3052 5.22153 13.3052C5.03525 13.3052 4.85661 13.235 4.7249 13.1101C4.59318 12.9853 4.51918 12.8159 4.51918 12.6394V6.00793C4.51918 5.83135 4.59318 5.662 4.7249 5.53714C4.85661 5.41228 5.03525 5.34214 5.22153 5.34214C5.4078 5.34214 5.58644 5.41228 5.71816 5.53714C5.84987 5.662 5.92387 5.83135 5.92387 6.00793V12.6394ZM9.43 12.6394C9.43868 12.7314 9.42704 12.8242 9.39583 12.9118C9.36461 12.9993 9.31451 13.0798 9.2487 13.148C9.1829 13.2162 9.10283 13.2706 9.01361 13.3079C8.92438 13.3452 8.82795 13.3644 8.73044 13.3644C8.63294 13.3644 8.53651 13.3452 8.44728 13.3079C8.35806 13.2706 8.27799 13.2162 8.21219 13.148C8.14638 13.0798 8.09628 12.9993 8.06506 12.9118C8.03385 12.8242 8.02221 12.7314 8.03089 12.6394V6.00793C8.04651 5.84227 8.12696 5.68815 8.25643 5.57589C8.38589 5.46364 8.55499 5.40139 8.73044 5.40139C8.9059 5.40139 9.07499 5.46364 9.20446 5.57589C9.33393 5.68815 9.41438 5.84227 9.43 6.00793V12.6394Z"
        fill="#4E84A1"
      />
    </svg>
  );
}

export function LeftArrowIconComponent() {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9L1 5L5 1"
        stroke="#5DC2FA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RightArrowIconComponent() {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L5 5L1 1"
        stroke="#5DC2FA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BlueEllipseIconComponent() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill="#5DC2FA" />
    </svg>
  );
}

export function GreyEllipseIconComponent() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill="#4E84A2" fillOpacity="0.2" />
    </svg>
  );
}

export function SubaccountSuccessIconComponent() {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4604 54.9624C-8.27879 72.9023 -10.1175 133.473 33.6049 132.314C53.1557 131.795 58.8679 111.292 76.5119 104.097C93.0767 97.3378 107.359 110.893 124.08 95.543C143.782 77.4753 146.613 33.2851 117.328 30.3311C104.577 29.044 99.6603 41.7754 88.5198 44.5934C65.9351 50.3096 45.301 41.6394 22.4604 54.9624Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.9"
        d="M22.4604 54.9624C-8.27879 72.9023 -10.1175 133.473 33.6049 132.314C53.1557 131.795 58.8679 111.292 76.5119 104.097C93.0767 97.3378 107.359 110.893 124.08 95.543C143.782 77.4753 146.613 33.2851 117.328 30.3311C104.577 29.044 99.6603 41.7754 88.5198 44.5934C65.9351 50.3096 45.301 41.6394 22.4604 54.9624Z"
        fill="white"
      />
      <path
        d="M112.79 42.5601H27.8276C25.0259 42.5601 22.7546 44.8313 22.7546 47.633V100.382C22.7546 103.184 25.0259 105.455 27.8276 105.455H112.79C115.592 105.455 117.863 103.184 117.863 100.382V47.633C117.863 44.8313 115.592 42.5601 112.79 42.5601Z"
        fill="#263238"
      />
      <path
        d="M19.04 101.392H122.08V101.636C122.08 103.03 121.526 104.367 120.54 105.353C119.554 106.339 118.217 106.893 116.823 106.893H24.2975C22.9032 106.893 21.5659 106.339 20.5799 105.353C19.594 104.367 19.04 103.03 19.04 101.636V101.392Z"
        fill="#263238"
      />
      <path
        d="M115.047 45.0603H25.3105V98.175H115.047V45.0603Z"
        fill="#263238"
      />
      <path
        d="M60.9331 100.803L62.2144 102.837H80.2048L81.3921 100.803H60.9331Z"
        fill="#455A64"
      />
      <path
        d="M112.241 46.856H28.2948C27.666 46.856 27.1562 47.3657 27.1562 47.9945V96.8614C27.1562 97.4902 27.666 97.9999 28.2948 97.9999H112.241C112.869 97.9999 113.379 97.4902 113.379 96.8614V47.9945C113.379 47.3657 112.869 46.856 112.241 46.856Z"
        fill="#EBEBEB"
      />
      <path
        d="M113.288 98.077H27.0654L27.156 50.6794H113.288V98.077Z"
        fill="white"
      />
      <path
        d="M34.2413 48.8341C34.2413 48.9718 34.2005 49.1064 34.124 49.2209C34.0475 49.3354 33.9387 49.4247 33.8115 49.4774C33.6842 49.5301 33.5442 49.5439 33.4091 49.517C33.2741 49.4902 33.15 49.4238 33.0526 49.3265C32.9552 49.2291 32.8889 49.105 32.862 48.9699C32.8351 48.8348 32.8489 48.6948 32.9016 48.5676C32.9543 48.4403 33.0436 48.3316 33.1581 48.2551C33.2726 48.1785 33.4073 48.1377 33.545 48.1377C33.7297 48.1377 33.9068 48.2111 34.0374 48.3417C34.168 48.4722 34.2413 48.6494 34.2413 48.8341Z"
        fill="#263238"
      />
      <path
        d="M30.0631 48.8341C30.0631 48.9718 30.0223 49.1064 29.9458 49.2209C29.8693 49.3354 29.7605 49.4247 29.6333 49.4774C29.506 49.5301 29.366 49.5439 29.2309 49.517C29.0958 49.4902 28.9718 49.4238 28.8744 49.3265C28.777 49.2291 28.7107 49.105 28.6838 48.9699C28.6569 48.8348 28.6707 48.6948 28.7234 48.5676C28.7761 48.4403 28.8654 48.3316 28.9799 48.2551C29.0944 48.1785 29.229 48.1377 29.3668 48.1377C29.5515 48.1377 29.7286 48.2111 29.8592 48.3417C29.9898 48.4722 30.0631 48.6494 30.0631 48.8341Z"
        fill="#263238"
      />
      <path
        d="M32.0582 48.8341C32.0582 48.9718 32.0174 49.1064 31.9409 49.2209C31.8644 49.3354 31.7556 49.4247 31.6284 49.4774C31.5011 49.5301 31.3611 49.5439 31.226 49.517C31.091 49.4902 30.9669 49.4238 30.8695 49.3265C30.7721 49.2291 30.7058 49.105 30.6789 48.9699C30.652 48.8348 30.6658 48.6948 30.7185 48.5676C30.7712 48.4403 30.8605 48.3316 30.975 48.2551C31.0895 48.1785 31.2242 48.1377 31.3619 48.1377C31.5466 48.1377 31.7237 48.2111 31.8543 48.3417C31.9849 48.4722 32.0582 48.6494 32.0582 48.8341Z"
        fill="#263238"
      />
      <path
        d="M117.045 100.803C117.045 100.838 95.9386 100.866 69.9053 100.866C43.872 100.866 22.7515 100.838 22.7515 100.803C22.7515 100.769 43.8581 100.741 69.9018 100.741C95.9456 100.741 117.045 100.769 117.045 100.803Z"
        fill="#455A64"
      />
      <path
        d="M113.379 58.3215H27.1562V77.5688H113.379V58.3215Z"
        fill="#F5F5F5"
      />
      <path
        d="M41.7169 53.2524H29.2729V56.5079H41.7169V53.2524Z"
        fill="#F5F5F5"
      />
      <path
        d="M111.335 53.2524H104.521V56.5079H111.335V53.2524Z"
        fill="#F5F5F5"
      />
      <path
        d="M102.474 53.2524H91.3252V56.5079H102.474V53.2524Z"
        fill="#F5F5F5"
      />
      <path
        d="M89.0061 53.2524H77.8574V56.5079H89.0061V53.2524Z"
        fill="#F5F5F5"
      />
      <path
        d="M107.362 88.927H31.3682V92.3391H107.362V88.927Z"
        fill="#F5F5F5"
      />
      <path
        d="M107.362 82.4712H31.3682V85.8833H107.362V82.4712Z"
        fill="#F5F5F5"
      />
      <path
        d="M70.5604 83.9999C76.7459 83.9999 81.7604 78.9855 81.7604 72.7999C81.7604 66.6143 76.7459 61.5999 70.5604 61.5999C64.3748 61.5999 59.3604 66.6143 59.3604 72.7999C59.3604 78.9855 64.3748 83.9999 70.5604 83.9999Z"
        fill="#59B855"
      />
      <path
        d="M64.96 72.7998L66.9841 70.9005L69.7788 73.4522L75.2808 68.3198L77.28 70.1944L69.7497 77.2798L64.96 72.7998Z"
        fill="white"
      />
    </svg>
  );
}

export function SubaccountSuccessWithInviteUserIconComponent() {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.4841 56.9037C5.68924 73.1252 4.02661 127.895 43.5611 126.846C61.2392 126.376 66.4042 107.838 82.3583 101.332C97.3364 95.2202 110.251 107.477 125.37 93.5973C143.185 77.2601 145.744 37.3027 119.265 34.6317C107.735 33.4678 103.289 44.9798 93.216 47.5279C72.7945 52.6965 54.1369 44.8569 33.4841 56.9037Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.9"
        d="M33.4841 56.9037C5.68924 73.1252 4.02661 127.895 43.5611 126.846C61.2392 126.376 66.4042 107.838 82.3583 101.332C97.3364 95.2202 110.251 107.477 125.37 93.5973C143.185 77.2601 145.744 37.3027 119.265 34.6317C107.735 33.4678 103.289 44.9798 93.216 47.5279C72.7945 52.6965 54.1369 44.8569 33.4841 56.9037Z"
        fill="white"
      />
      <path
        d="M12.9629 59.3564L95.3608 71.219L106.417 82.3767L12.9629 59.3564Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.6"
        d="M12.9629 59.3564L95.3608 71.219L106.417 82.3767L12.9629 59.3564Z"
        fill="white"
      />
      <path
        d="M12.9629 59.3564L95.3608 71.219L91.5367 87.3537L12.9629 59.3564Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.2"
        d="M12.9629 59.3564L95.3608 71.219L91.5367 87.3537L12.9629 59.3564Z"
        fill="white"
      />
      <path
        d="M89.8451 40.6773L94.627 63.0867C94.7514 63.6718 94.6386 64.2824 94.3133 64.7845C93.9881 65.2866 93.4769 65.6392 92.892 65.7649L50.213 74.8733C49.6279 74.9967 49.0178 74.8835 48.5159 74.5584C48.0141 74.2333 47.6613 73.7228 47.5347 73.1384L42.7492 50.729C42.6259 50.1434 42.7396 49.5328 43.0655 49.0308C43.3913 48.5289 43.9027 48.1765 44.4878 48.0507L87.1668 38.9424C87.7524 38.8191 88.363 38.9328 88.8649 39.2586C89.3669 39.5844 89.7193 40.0958 89.8451 40.6809V40.6773Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.4"
        d="M89.8451 40.6773L94.627 63.0867C94.7514 63.6718 94.6386 64.2824 94.3133 64.7845C93.9881 65.2866 93.4769 65.6392 92.892 65.7649L50.213 74.8733C49.6279 74.9967 49.0178 74.8835 48.5159 74.5584C48.0141 74.2333 47.6613 73.7228 47.5347 73.1384L42.7492 50.729C42.6259 50.1434 42.7396 49.5328 43.0655 49.0308C43.3913 48.5289 43.9027 48.1765 44.4878 48.0507L87.1668 38.9424C87.7524 38.8191 88.363 38.9328 88.8649 39.2586C89.3669 39.5844 89.7193 40.0958 89.8451 40.6809V40.6773Z"
        fill="white"
      />
      <path
        d="M88.7935 39.2093L74.5346 56.714C73.2122 58.3369 71.3754 59.4598 69.3281 59.8968C67.2807 60.3339 65.1455 60.059 63.2757 59.1175L43.1108 48.961C43.4371 48.4924 43.9294 48.1655 44.4879 48.0466L87.167 38.9383C87.7239 38.8197 88.3051 38.9166 88.7935 39.2093Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        d="M12.9629 59.3564L80.9248 75.5093L91.5367 87.3537L12.9629 59.3564Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.6"
        d="M12.9629 59.3564L80.9248 75.5093L91.5367 87.3537L12.9629 59.3564Z"
        fill="white"
      />
      <path
        d="M37.7537 74.9252L37.571 75.2371L45.134 79.6671L45.3167 79.3553L37.7537 74.9252Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        d="M48.6558 81.3082L48.4731 81.6201L51.1927 83.2131L51.3754 82.9012L48.6558 81.3082Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        d="M12.9629 59.3564L80.9248 75.5093L67.7141 91.4308L12.9629 59.3564Z"
        fill="#4E84A2"
      />
      <path
        d="M103.865 97.1994C103.774 97.1997 103.683 97.1825 103.598 97.1488L92.5307 92.7682C92.3536 92.6968 92.2119 92.5584 92.1366 92.383C92.0612 92.2076 92.0583 92.0095 92.1285 91.832C92.1986 91.6544 92.3362 91.5119 92.511 91.4354C92.6859 91.3588 92.884 91.3546 93.062 91.4236L104.133 95.8043C104.29 95.8662 104.42 95.9808 104.501 96.1284C104.582 96.276 104.609 96.4473 104.577 96.6127C104.545 96.7781 104.457 96.9272 104.327 97.0343C104.197 97.1415 104.034 97.1999 103.865 97.1994Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.3"
        d="M103.865 97.1994C103.774 97.1997 103.683 97.1825 103.598 97.1488L92.5307 92.7682C92.3536 92.6968 92.2119 92.5584 92.1366 92.383C92.0612 92.2076 92.0583 92.0095 92.1285 91.832C92.1986 91.6544 92.3362 91.5119 92.511 91.4354C92.6859 91.3588 92.884 91.3546 93.062 91.4236L104.133 95.8043C104.29 95.8662 104.42 95.9808 104.501 96.1284C104.582 96.276 104.609 96.4473 104.577 96.6127C104.545 96.7781 104.457 96.9272 104.327 97.0343C104.197 97.1415 104.034 97.1999 103.865 97.1994Z"
        fill="white"
      />
      <path
        d="M103.211 90.8518C103.121 90.8512 103.031 90.8328 102.947 90.7976L97.0017 88.4301C96.9128 88.3957 96.8316 88.344 96.7628 88.278C96.694 88.2121 96.6388 88.1332 96.6006 88.0458C96.5624 87.9585 96.5419 87.8644 96.5402 87.7691C96.5384 87.6738 96.5556 87.5791 96.5906 87.4904C96.6257 87.4018 96.6779 87.3209 96.7443 87.2525C96.8107 87.1841 96.89 87.1295 96.9776 87.0919C97.0652 87.0543 97.1594 87.0343 97.2547 87.0333C97.35 87.0322 97.4446 87.0499 97.533 87.0856L103.479 89.4422C103.657 89.5123 103.8 89.6502 103.877 89.8258C103.953 90.0013 103.957 90.2 103.887 90.3783C103.836 90.5168 103.744 90.6363 103.623 90.721C103.503 90.8056 103.359 90.8513 103.211 90.8518Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.5"
        d="M103.211 90.8518C103.121 90.8512 103.031 90.8328 102.947 90.7976L97.0017 88.4301C96.9128 88.3957 96.8316 88.344 96.7628 88.278C96.694 88.2121 96.6388 88.1332 96.6006 88.0458C96.5624 87.9585 96.5419 87.8644 96.5402 87.7691C96.5384 87.6738 96.5556 87.5791 96.5906 87.4904C96.6257 87.4018 96.6779 87.3209 96.7443 87.2525C96.8107 87.1841 96.89 87.1295 96.9776 87.0919C97.0652 87.0543 97.1594 87.0343 97.2547 87.0333C97.35 87.0322 97.4446 87.0499 97.533 87.0856L103.479 89.4422C103.657 89.5123 103.8 89.6502 103.877 89.8258C103.953 90.0013 103.957 90.2 103.887 90.3783C103.836 90.5168 103.744 90.6363 103.623 90.721C103.503 90.8056 103.359 90.8513 103.211 90.8518Z"
        fill="white"
      />
      <path
        d="M90.7813 97.1048C90.6911 97.1038 90.6017 97.0866 90.5175 97.0542L79.7212 92.7675C79.6323 92.7331 79.5511 92.6814 79.4823 92.6154C79.4134 92.5495 79.3583 92.4706 79.3201 92.3832C79.2819 92.2959 79.2614 92.2018 79.2596 92.1065C79.2579 92.0112 79.2751 91.9165 79.3101 91.8278C79.3451 91.7392 79.3974 91.6583 79.4638 91.5899C79.5302 91.5215 79.6095 91.4669 79.6971 91.4293C79.7847 91.3917 79.8788 91.3717 79.9742 91.3707C80.0695 91.3696 80.1641 91.3873 80.2525 91.423L91.0488 95.6952C91.2054 95.7571 91.3355 95.8717 91.4166 96.0193C91.4977 96.1669 91.5247 96.3382 91.493 96.5036C91.4613 96.669 91.3729 96.8181 91.2429 96.9253C91.113 97.0324 90.9497 97.0908 90.7813 97.0904V97.1048Z"
        fill="#4E84A2"
        fillOpacity="0.58"
      />
      <path
        opacity="0.3"
        d="M90.7813 97.1048C90.6911 97.1038 90.6017 97.0866 90.5175 97.0542L79.7212 92.7675C79.6323 92.7331 79.5511 92.6814 79.4823 92.6154C79.4134 92.5495 79.3583 92.4706 79.3201 92.3832C79.2819 92.2959 79.2614 92.2018 79.2596 92.1065C79.2579 92.0112 79.2751 91.9165 79.3101 91.8278C79.3451 91.7392 79.3974 91.6583 79.4638 91.5899C79.5302 91.5215 79.6095 91.4669 79.6971 91.4293C79.7847 91.3917 79.8788 91.3717 79.9742 91.3707C80.0695 91.3696 80.1641 91.3873 80.2525 91.423L91.0488 95.6952C91.2054 95.7571 91.3355 95.8717 91.4166 96.0193C91.4977 96.1669 91.5247 96.3382 91.493 96.5036C91.4613 96.669 91.3729 96.8181 91.2429 96.9253C91.113 97.0324 90.9497 97.0908 90.7813 97.0904V97.1048Z"
        fill="white"
      />
      <path
        d="M117.321 106.087C123.352 107.461 129.354 103.684 130.727 97.6531C132.101 91.6218 128.324 85.6194 122.293 84.2463C116.262 82.8731 110.259 86.6493 108.886 92.6806C107.513 98.7118 111.289 104.714 117.321 106.087Z"
        fill="#59B855"
      />
      <path
        d="M114.347 93.9236L116.742 92.521L118.9 95.6295L125.404 91.8465L126.938 94.1181L118.022 99.3551L114.347 93.9236Z"
        fill="white"
      />
    </svg>
  );
}

export function CrossIconComponent() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.882887 1.07354L0.96967 0.96967C1.23002 0.709321 1.63416 0.680393 1.92646 0.882887L2.03033 0.96967L9 7.9395L15.9697 0.96967C16.2626 0.676777 16.7374 0.676777 17.0303 0.96967C17.3232 1.26256 17.3232 1.73744 17.0303 2.03033L10.0605 9L17.0303 15.9697C17.2907 16.23 17.3196 16.6342 17.1171 16.9265L17.0303 17.0303C16.77 17.2907 16.3658 17.3196 16.0735 17.1171L15.9697 17.0303L9 10.0605L2.03033 17.0303C1.73744 17.3232 1.26256 17.3232 0.96967 17.0303C0.676777 16.7374 0.676777 16.2626 0.96967 15.9697L7.9395 9L0.96967 2.03033C0.709321 1.76998 0.680393 1.36584 0.882887 1.07354L0.96967 0.96967L0.882887 1.07354Z"
        fill="#606062"
      />
    </svg>
  );
}

export function InfoIconComponent() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.387 0 9 0ZM9 16.5C7.51664 16.5 6.0666 16.0601 4.83323 15.236C3.59986 14.4119 2.63856 13.2406 2.07091 11.8701C1.50325 10.4997 1.35473 8.99168 1.64411 7.53682C1.9335 6.08197 2.64781 4.74559 3.6967 3.6967C4.7456 2.64781 6.08197 1.9335 7.53683 1.64411C8.99168 1.35472 10.4997 1.50325 11.8701 2.0709C13.2406 2.63856 14.4119 3.59985 15.236 4.83322C16.0601 6.06659 16.5 7.51664 16.5 9C16.5 10.9891 15.7098 12.8968 14.3033 14.3033C12.8968 15.7098 10.9891 16.5 9 16.5Z"
        fill="#606062"
      />
      <path
        d="M8.99938 7.27498C8.80047 7.27498 8.6097 7.354 8.46905 7.49465C8.3284 7.6353 8.24938 7.82607 8.24938 8.02498V13.125C8.24938 13.3239 8.3284 13.5147 8.46905 13.6553C8.6097 13.796 8.80047 13.875 8.99938 13.875C9.19829 13.875 9.38906 13.796 9.52971 13.6553C9.67036 13.5147 9.74938 13.3239 9.74938 13.125V8.02498C9.74938 7.82607 9.67036 7.6353 9.52971 7.49465C9.38906 7.354 9.19829 7.27498 8.99938 7.27498ZM8.99938 4.19998C8.79634 4.20762 8.60394 4.2927 8.46167 4.43775C8.3194 4.58281 8.23807 4.77684 8.23438 4.97998V5.09998C8.23402 5.19784 8.25404 5.29469 8.29317 5.38439C8.33229 5.47408 8.38965 5.55465 8.46161 5.62097C8.53357 5.68728 8.61854 5.73789 8.71113 5.76957C8.80371 5.80125 8.90188 5.81331 8.99938 5.80498C9.19592 5.79756 9.3824 5.71616 9.52148 5.57708C9.66055 5.43801 9.74196 5.25152 9.74938 5.05498V4.87498C9.74997 4.77966 9.73036 4.68529 9.69185 4.5981C9.65334 4.5109 9.5968 4.43285 9.52594 4.36908C9.45509 4.30531 9.37153 4.25727 9.28077 4.22813C9.19002 4.19898 9.09411 4.18939 8.99938 4.19998Z"
        fill="#606062"
      />
    </svg>
  );
}

export function DarkInfoIconComponent() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5H11V7H9V5ZM10 15C10.55 15 11 14.55 11 14V10C11 9.45 10.55 9 10 9C9.45 9 9 9.45 9 10V14C9 14.55 9.45 15 10 15ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
        fill="#606062"
      />
    </svg>
  );
}

export function BlueCheckIconComponent() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_930_16750)">
        <path
          d="M13.0006 20.1703L9.53063 16.7003C9.14063 16.3103 8.51063 16.3103 8.12062 16.7003C7.73063 17.0903 7.73063 17.7203 8.12062 18.1103L12.3006 22.2903C12.6906 22.6803 13.3206 22.6803 13.7106 22.2903L24.2906 11.7103C24.6806 11.3203 24.6806 10.6903 24.2906 10.3003C23.9006 9.91031 23.2706 9.91031 22.8806 10.3003L13.0006 20.1703Z"
          fill="#4E84A1"
        />
      </g>
      <rect
        x="0.75"
        y="0.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="#4E84A1"
        strokeWidth="1.5"
      />
      <defs>
        <clipPath id="clip0_930_16750">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EmptyCheckIconComponent() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="#606062"
        strokeWidth="1.5"
        strokeDasharray="3 3"
      />
    </svg>
  );
}

export function CircleCheckGreenIconComponent() {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.586914C5.4 0.586914 0 5.46297 0 11.4226C0 17.3822 5.4 22.2583 12 22.2583C18.6 22.2583 24 17.3822 24 11.4226C24 5.46297 18.6 0.586914 12 0.586914ZM9.6 16.8404L3.6 11.4226L5.28 9.90561L9.6 13.8065L18.72 5.57133L20.4 7.08833L9.6 16.8404Z"
        fill="#55DC4F"
      />
    </svg>
  );
}

export function CaretRightIconComponent() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.02637 16.0264L0.973336 0.0264549L16.9998 7.97338L1.02637 16.0264Z"
        fill="#999999"
      />
    </svg>
  );
}

export function BlackTickIconComponent() {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97794 9.89984C4.85384 10.0247 4.68454 10.0943 4.50867 10.0943C4.3328 10.0943 4.16349 10.0247 4.0394 9.89984L0.291697 6.15153C-0.0972324 5.7626 -0.0972324 5.13193 0.291697 4.74373L0.760965 4.27434C1.15002 3.88541 1.77996 3.88541 2.16889 4.27434L4.50867 6.61423L10.8311 0.291697C11.2201 -0.0972324 11.8507 -0.0972324 12.239 0.291697L12.7083 0.761087C13.0972 1.15002 13.0972 1.78057 12.7083 2.16889L4.97794 9.89984Z"
        fill="black"
      />
    </svg>
  );
}

export function BlackCrossIconComponent() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15075 11.9937C0.853129 12.011 0.560429 11.912 0.334371 11.7177C-0.111457 11.2692 -0.111457 10.5449 0.334371 10.0964L10.0966 0.334202C10.5603 -0.0996987 11.2879 -0.0755784 11.7218 0.388123C12.1141 0.807445 12.137 1.45195 11.7753 1.89801L1.95562 11.7177C1.73248 11.9092 1.44447 12.008 1.15075 11.9937Z"
        fill="black"
      />
      <path
        d="M10.9022 11.9935C10.6006 11.9922 10.3115 11.8725 10.0973 11.66L0.33508 1.89778C-0.077957 1.41545 -0.0218024 0.689569 0.460529 0.276494C0.891022 -0.0921647 1.52591 -0.0921647 1.95637 0.276494L11.7761 10.0387C12.2397 10.4727 12.2636 11.2004 11.8296 11.664C11.8123 11.6824 11.7945 11.7003 11.7761 11.7175C11.5356 11.9266 11.2192 12.0265 10.9022 11.9935Z"
        fill="black"
      />
    </svg>
  );
}

export function GrayAboutIconComponent() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12962 0.192094C5.59746 0.513047 4.17685 1.22212 3.00817 2.24924C1.83948 3.27636 0.963175 4.58599 0.465827 6.04872C-0.0315216 7.51144 -0.132696 9.07665 0.172301 10.5897C0.477298 12.1027 1.17791 13.5112 2.20491 14.6759C2.32724 14.8208 2.39957 15.0002 2.41142 15.1882C2.42327 15.3763 2.37403 15.5631 2.27083 15.7218L1.85713 16.3782C1.77255 16.5124 1.72593 16.6664 1.7221 16.8243C1.71827 16.9823 1.75737 17.1383 1.83536 17.2764C1.91334 17.4144 2.02736 17.5294 2.16564 17.6095C2.30391 17.6896 2.4614 17.7318 2.62181 17.7318H8.74588C11.0725 17.7565 13.3217 16.9095 15.0379 15.3624C16.7541 13.8153 17.809 11.6837 17.989 9.39933C18.0713 8.03622 17.8329 6.67281 17.2925 5.41524C16.7522 4.15768 15.9243 3.0399 14.8735 2.14894C13.8227 1.25798 12.5772 0.617873 11.234 0.278463C9.89086 -0.0609476 8.48627 -0.0905042 7.12962 0.192094ZM9.00437 3.22855C9.25333 3.22857 9.4967 3.30129 9.70369 3.4375C9.91069 3.57372 10.072 3.76733 10.1673 3.99383C10.2625 4.22034 10.2874 4.46957 10.2389 4.71002C10.1903 4.95047 10.0704 5.17134 9.89434 5.34469C9.71829 5.51804 9.494 5.63609 9.24982 5.68391C9.00564 5.73173 8.75254 5.70718 8.52253 5.61335C8.29253 5.51953 8.09593 5.36065 7.95762 5.1568C7.81931 4.95295 7.74548 4.7133 7.74548 4.46813C7.74551 4.13937 7.87816 3.82408 8.11424 3.59161C8.35033 3.35915 8.67051 3.22855 9.00437 3.22855ZM10.0112 13.7031H9.00437C8.89692 13.7031 8.7905 13.6823 8.69122 13.6418C8.59194 13.6014 8.50173 13.542 8.42574 13.4672C8.34976 13.3924 8.28949 13.3035 8.24838 13.2058C8.20727 13.108 8.18612 13.0032 8.18615 12.8974V8.74477H7.99758C7.78057 8.74477 7.57245 8.65988 7.41901 8.50878C7.26556 8.35767 7.17936 8.15273 7.17936 7.93903C7.17936 7.72534 7.26556 7.5204 7.41901 7.36929C7.57245 7.21819 7.78057 7.1333 7.99758 7.1333H9.00437C9.11183 7.13327 9.21824 7.15409 9.31753 7.19458C9.41681 7.23506 9.50702 7.29441 9.583 7.36923C9.65899 7.44406 9.71926 7.53289 9.76037 7.63066C9.80148 7.72843 9.82262 7.83322 9.82259 7.93903V12.0916H10.0112C10.2282 12.0916 10.4363 12.1765 10.5897 12.3276C10.7432 12.4787 10.8294 12.6837 10.8294 12.8974C10.8294 13.1111 10.7432 13.316 10.5897 13.4671C10.4363 13.6182 10.2282 13.7031 10.0112 13.7031Z"
        fill="#EEEBDF"
      />
    </svg>
  );
}

export function GrayCrossIconComponent() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15075 11.9937C0.853129 12.011 0.560429 11.912 0.334371 11.7177C-0.111457 11.2692 -0.111457 10.5449 0.334371 10.0964L10.0966 0.334202C10.5603 -0.0996987 11.2879 -0.0755784 11.7218 0.388123C12.1141 0.807445 12.137 1.45195 11.7753 1.89801L1.95562 11.7177C1.73248 11.9092 1.44447 12.008 1.15075 11.9937Z"
        fill="#A9A388"
      />
      <path
        d="M10.9022 11.9935C10.6006 11.9922 10.3115 11.8725 10.0973 11.66L0.33508 1.89778C-0.077957 1.41545 -0.0218024 0.689569 0.460529 0.276494C0.891022 -0.0921647 1.52591 -0.0921647 1.95637 0.276494L11.7761 10.0387C12.2397 10.4727 12.2636 11.2004 11.8296 11.664C11.8123 11.6824 11.7945 11.7003 11.7761 11.7175C11.5356 11.9266 11.2192 12.0265 10.9022 11.9935Z"
        fill="#A9A388"
      />
    </svg>
  );
}

export function GrayTickIconComponent() {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97794 9.89984C4.85384 10.0247 4.68454 10.0943 4.50867 10.0943C4.3328 10.0943 4.16349 10.0247 4.0394 9.89984L0.291697 6.15153C-0.0972324 5.7626 -0.0972324 5.13193 0.291697 4.74373L0.760965 4.27434C1.15002 3.88541 1.77996 3.88541 2.16889 4.27434L4.50867 6.61423L10.8311 0.291697C11.2201 -0.0972324 11.8507 -0.0972324 12.239 0.291697L12.7083 0.761087C13.0972 1.15002 13.0972 1.78057 12.7083 2.16889L4.97794 9.89984Z"
        fill="#999999"
      />
    </svg>
  );
}

export function GreenAboutIconComponent() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12962 0.192094C5.59746 0.513047 4.17685 1.22212 3.00817 2.24924C1.83948 3.27636 0.963175 4.58599 0.465827 6.04872C-0.0315216 7.51144 -0.132696 9.07665 0.172301 10.5897C0.477298 12.1027 1.17791 13.5112 2.20491 14.6759C2.32724 14.8208 2.39957 15.0002 2.41142 15.1882C2.42327 15.3763 2.37403 15.5631 2.27083 15.7218L1.85713 16.3782C1.77255 16.5124 1.72593 16.6664 1.7221 16.8243C1.71827 16.9823 1.75737 17.1383 1.83536 17.2764C1.91334 17.4144 2.02736 17.5294 2.16564 17.6095C2.30391 17.6896 2.4614 17.7318 2.62181 17.7318H8.74588C11.0725 17.7565 13.3217 16.9095 15.0379 15.3624C16.7541 13.8153 17.809 11.6837 17.989 9.39933C18.0713 8.03622 17.8329 6.67281 17.2925 5.41524C16.7522 4.15768 15.9243 3.0399 14.8735 2.14894C13.8227 1.25798 12.5772 0.617873 11.234 0.278463C9.89086 -0.0609476 8.48627 -0.0905042 7.12962 0.192094ZM9.00437 3.22855C9.25333 3.22857 9.4967 3.30129 9.70369 3.4375C9.91069 3.57372 10.072 3.76733 10.1673 3.99383C10.2625 4.22034 10.2874 4.46957 10.2389 4.71002C10.1903 4.95047 10.0704 5.17134 9.89434 5.34469C9.71829 5.51804 9.494 5.63609 9.24982 5.68391C9.00564 5.73173 8.75254 5.70718 8.52253 5.61335C8.29253 5.51953 8.09593 5.36065 7.95762 5.1568C7.81931 4.95295 7.74548 4.7133 7.74548 4.46813C7.74551 4.13937 7.87816 3.82408 8.11424 3.59161C8.35033 3.35915 8.67051 3.22855 9.00437 3.22855ZM10.0112 13.7031H9.00437C8.89692 13.7031 8.7905 13.6823 8.69122 13.6418C8.59194 13.6014 8.50173 13.542 8.42574 13.4672C8.34976 13.3924 8.28949 13.3035 8.24838 13.2058C8.20727 13.108 8.18612 13.0032 8.18615 12.8974V8.74477H7.99758C7.78057 8.74477 7.57245 8.65988 7.41901 8.50878C7.26556 8.35767 7.17936 8.15273 7.17936 7.93903C7.17936 7.72534 7.26556 7.5204 7.41901 7.36929C7.57245 7.21819 7.78057 7.1333 7.99758 7.1333H9.00437C9.11183 7.13327 9.21824 7.15409 9.31753 7.19458C9.41681 7.23506 9.50702 7.29441 9.583 7.36923C9.65899 7.44406 9.71926 7.53289 9.76037 7.63066C9.80148 7.72843 9.82262 7.83322 9.82259 7.93903V12.0916H10.0112C10.2282 12.0916 10.4363 12.1765 10.5897 12.3276C10.7432 12.4787 10.8294 12.6837 10.8294 12.8974C10.8294 13.1111 10.7432 13.316 10.5897 13.4671C10.4363 13.6182 10.2282 13.7031 10.0112 13.7031Z"
        fill="#1AC67D"
        fillOpacity="0.5"
      />
    </svg>
  );
}

export function GreenTickIconComponent() {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97794 9.89984C4.85384 10.0247 4.68454 10.0943 4.50867 10.0943C4.3328 10.0943 4.16349 10.0247 4.0394 9.89984L0.291697 6.15153C-0.0972324 5.7626 -0.0972324 5.13193 0.291697 4.74373L0.760965 4.27434C1.15002 3.88541 1.77996 3.88541 2.16889 4.27434L4.50867 6.61423L10.8311 0.291697C11.2201 -0.0972324 11.8507 -0.0972324 12.239 0.291697L12.7083 0.761087C13.0972 1.15002 13.0972 1.78057 12.7083 2.16889L4.97794 9.89984Z"
        fill="#1AC67D"
      />
    </svg>
  );
}

export function PinkAboutIconComponent() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12962 0.192094C5.59746 0.513047 4.17685 1.22212 3.00817 2.24924C1.83948 3.27636 0.963175 4.58599 0.465827 6.04872C-0.0315216 7.51144 -0.132696 9.07665 0.172301 10.5897C0.477298 12.1027 1.17791 13.5112 2.20491 14.6759C2.32724 14.8208 2.39957 15.0002 2.41142 15.1882C2.42327 15.3763 2.37403 15.5631 2.27083 15.7218L1.85713 16.3782C1.77255 16.5124 1.72593 16.6664 1.7221 16.8243C1.71827 16.9823 1.75737 17.1383 1.83536 17.2764C1.91334 17.4144 2.02736 17.5294 2.16564 17.6095C2.30391 17.6896 2.4614 17.7318 2.62181 17.7318H8.74588C11.0725 17.7565 13.3217 16.9095 15.0379 15.3624C16.7541 13.8153 17.809 11.6837 17.989 9.39933C18.0713 8.03622 17.8329 6.67281 17.2925 5.41524C16.7522 4.15768 15.9243 3.0399 14.8735 2.14894C13.8227 1.25798 12.5772 0.617873 11.234 0.278463C9.89086 -0.0609476 8.48627 -0.0905042 7.12962 0.192094ZM9.00437 3.22855C9.25333 3.22857 9.4967 3.30129 9.70369 3.4375C9.91069 3.57372 10.072 3.76733 10.1673 3.99383C10.2625 4.22034 10.2874 4.46957 10.2389 4.71002C10.1903 4.95047 10.0704 5.17134 9.89434 5.34469C9.71829 5.51804 9.494 5.63609 9.24982 5.68391C9.00564 5.73173 8.75254 5.70718 8.52253 5.61335C8.29253 5.51953 8.09593 5.36065 7.95762 5.1568C7.81931 4.95295 7.74548 4.7133 7.74548 4.46813C7.74551 4.13937 7.87816 3.82408 8.11424 3.59161C8.35033 3.35915 8.67051 3.22855 9.00437 3.22855ZM10.0112 13.7031H9.00437C8.89692 13.7031 8.7905 13.6823 8.69122 13.6418C8.59194 13.6014 8.50173 13.542 8.42574 13.4672C8.34976 13.3924 8.28949 13.3035 8.24838 13.2058C8.20727 13.108 8.18612 13.0032 8.18615 12.8974V8.74477H7.99758C7.78057 8.74477 7.57245 8.65988 7.41901 8.50878C7.26556 8.35767 7.17936 8.15273 7.17936 7.93903C7.17936 7.72534 7.26556 7.5204 7.41901 7.36929C7.57245 7.21819 7.78057 7.1333 7.99758 7.1333H9.00437C9.11183 7.13327 9.21824 7.15409 9.31753 7.19458C9.41681 7.23506 9.50702 7.29441 9.583 7.36923C9.65899 7.44406 9.71926 7.53289 9.76037 7.63066C9.80148 7.72843 9.82262 7.83322 9.82259 7.93903V12.0916H10.0112C10.2282 12.0916 10.4363 12.1765 10.5897 12.3276C10.7432 12.4787 10.8294 12.6837 10.8294 12.8974C10.8294 13.1111 10.7432 13.316 10.5897 13.4671C10.4363 13.6182 10.2282 13.7031 10.0112 13.7031Z"
        fill="#EF3A7B"
        fillOpacity="0.5"
      />
    </svg>
  );
}

export function PinkTickIconComponent() {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97794 9.89984C4.85384 10.0247 4.68454 10.0943 4.50867 10.0943C4.3328 10.0943 4.16349 10.0247 4.0394 9.89984L0.291697 6.15153C-0.0972324 5.7626 -0.0972324 5.13193 0.291697 4.74373L0.760965 4.27434C1.15002 3.88541 1.77996 3.88541 2.16889 4.27434L4.50867 6.61423L10.8311 0.291697C11.2201 -0.0972324 11.8507 -0.0972324 12.239 0.291697L12.7083 0.761087C13.0972 1.15002 13.0972 1.78057 12.7083 2.16889L4.97794 9.89984Z"
        fill="#EF3A7B"
      />
    </svg>
  );
}

export function PinkCrossIconComponent() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15075 11.9937C0.853129 12.011 0.560429 11.912 0.334371 11.7177C-0.111457 11.2692 -0.111457 10.5449 0.334371 10.0964L10.0966 0.334202C10.5603 -0.0996987 11.2879 -0.0755784 11.7218 0.388123C12.1141 0.807445 12.137 1.45195 11.7753 1.89801L1.95562 11.7177C1.73248 11.9092 1.44447 12.008 1.15075 11.9937Z"
        fill="#EF3A7B"
      />
      <path
        d="M10.9022 11.9935C10.6006 11.9922 10.3115 11.8725 10.0973 11.66L0.33508 1.89778C-0.077957 1.41545 -0.0218024 0.689569 0.460529 0.276494C0.891022 -0.0921647 1.52591 -0.0921647 1.95637 0.276494L11.7761 10.0387C12.2397 10.4727 12.2636 11.2004 11.8296 11.664C11.8123 11.6824 11.7945 11.7003 11.7761 11.7175C11.5356 11.9266 11.2192 12.0265 10.9022 11.9935Z"
        fill="#EF3A7B"
      />
    </svg>
  );
}

export function RedCrossIconComponent() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15075 11.9937C0.853129 12.011 0.560429 11.912 0.334371 11.7177C-0.111457 11.2692 -0.111457 10.5449 0.334371 10.0964L10.0966 0.334202C10.5603 -0.0996987 11.2879 -0.0755784 11.7218 0.388123C12.1141 0.807445 12.137 1.45195 11.7753 1.89801L1.95562 11.7177C1.73248 11.9092 1.44447 12.008 1.15075 11.9937Z"
        fill="red"
      />
      <path
        d="M10.9022 11.9935C10.6006 11.9922 10.3115 11.8725 10.0973 11.66L0.33508 1.89778C-0.077957 1.41545 -0.0218024 0.689569 0.460529 0.276494C0.891022 -0.0921647 1.52591 -0.0921647 1.95637 0.276494L11.7761 10.0387C12.2397 10.4727 12.2636 11.2004 11.8296 11.664C11.8123 11.6824 11.7945 11.7003 11.7761 11.7175C11.5356 11.9266 11.2192 12.0265 10.9022 11.9935Z"
        fill="red"
      />
    </svg>
  );
}

export function BlueInfoIconComponent() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12962 0.192094C5.59746 0.513047 4.17685 1.22212 3.00817 2.24924C1.83948 3.27636 0.963175 4.58599 0.465827 6.04872C-0.0315216 7.51144 -0.132696 9.07665 0.172301 10.5897C0.477298 12.1027 1.17791 13.5112 2.20491 14.6759C2.32724 14.8208 2.39957 15.0002 2.41142 15.1882C2.42327 15.3763 2.37403 15.5631 2.27083 15.7218L1.85713 16.3782C1.77255 16.5124 1.72593 16.6664 1.7221 16.8243C1.71827 16.9823 1.75737 17.1383 1.83536 17.2764C1.91334 17.4144 2.02736 17.5294 2.16564 17.6095C2.30391 17.6896 2.4614 17.7318 2.62181 17.7318H8.74588C11.0725 17.7565 13.3217 16.9095 15.0379 15.3624C16.7541 13.8153 17.809 11.6837 17.989 9.39933C18.0713 8.03622 17.8329 6.67281 17.2925 5.41524C16.7522 4.15768 15.9243 3.0399 14.8735 2.14894C13.8227 1.25798 12.5772 0.617873 11.234 0.278463C9.89086 -0.0609476 8.48627 -0.0905042 7.12962 0.192094ZM9.00437 3.22855C9.25333 3.22857 9.4967 3.30129 9.70369 3.4375C9.91069 3.57372 10.072 3.76733 10.1673 3.99383C10.2625 4.22034 10.2874 4.46957 10.2389 4.71002C10.1903 4.95047 10.0704 5.17134 9.89434 5.34469C9.71829 5.51804 9.494 5.63609 9.24982 5.68391C9.00564 5.73173 8.75254 5.70718 8.52253 5.61335C8.29253 5.51953 8.09593 5.36065 7.95762 5.1568C7.81931 4.95295 7.74548 4.7133 7.74548 4.46813C7.74551 4.13937 7.87816 3.82408 8.11424 3.59161C8.35033 3.35915 8.67051 3.22855 9.00437 3.22855ZM10.0112 13.7031H9.00437C8.89692 13.7031 8.7905 13.6823 8.69122 13.6418C8.59194 13.6014 8.50173 13.542 8.42574 13.4672C8.34976 13.3924 8.28949 13.3035 8.24838 13.2058C8.20727 13.108 8.18612 13.0032 8.18615 12.8974V8.74477H7.99758C7.78057 8.74477 7.57245 8.65988 7.41901 8.50878C7.26556 8.35767 7.17936 8.15273 7.17936 7.93903C7.17936 7.72534 7.26556 7.5204 7.41901 7.36929C7.57245 7.21819 7.78057 7.1333 7.99758 7.1333H9.00437C9.11183 7.13327 9.21824 7.15409 9.31753 7.19458C9.41681 7.23506 9.50702 7.29441 9.583 7.36923C9.65899 7.44406 9.71926 7.53289 9.76037 7.63066C9.80148 7.72843 9.82262 7.83322 9.82259 7.93903V12.0916H10.0112C10.2282 12.0916 10.4363 12.1765 10.5897 12.3276C10.7432 12.4787 10.8294 12.6837 10.8294 12.8974C10.8294 13.1111 10.7432 13.316 10.5897 13.4671C10.4363 13.6182 10.2282 13.7031 10.0112 13.7031Z"
        fill="#4E83FB"
        fillOpacity="0.5"
      />
    </svg>
  );
}

export function SaveGreenIconComponent() {
  return (
    <svg
      width="98"
      height="31"
      viewBox="0 0 98 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.14633 0H96C97.1046 0 98 0.89543 98 2V29C98 30.1046 97.1046 31 96 31H2.23607C0.749304 31 -0.217688 29.4354 0.447213 28.1056L6.06685 16.8663C6.34042 16.3192 6.34855 15.6769 6.08891 15.123L0.335407 2.84887C-0.286271 1.52262 0.681604 0 2.14633 0Z"
        fill="#55DC4F"
      />
    </svg>
  );
}

export function GreenPinIconComponent() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8332 0H14.8279C14.2322 0 13.3995 0.34512 12.9786 0.765713L0.63227 13.112C-0.210757 13.9541 -0.210757 15.3347 0.63227 16.1758L9.82514 25.3683C10.6663 26.2104 12.0455 26.2104 12.8879 25.3673L25.2343 13.023C25.6548 12.6024 26 11.7685 26 11.174V2.16676C26 0.975311 25.0246 0 23.8332 0ZM19.4997 8.66671C18.303 8.66671 17.3329 7.69559 17.3329 6.49996C17.3329 5.30235 18.303 4.3332 19.4997 4.3332C20.6963 4.3332 21.6667 5.30235 21.6667 6.49996C21.6668 7.69559 20.6963 8.66671 19.4997 8.66671Z"
        fill="#55DC4F"
      />
    </svg>
  );
}

export function LightningBoltIconComponent() {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.36511 0.545572C9.65796 0.235053 10.1685 0.537718 10.0365 0.943646L7.84783 7.67823H12.8293C13.1791 7.67823 13.3604 8.09553 13.1217 8.3512L4.67468 17.3987C4.38104 17.7132 3.86587 17.4058 4.00323 16.998L6.02174 11.006H0.427061C0.0763186 11.006 -0.104587 10.5867 0.136059 10.3315L9.36511 0.545572Z"
        fill="#4EC3E0"
      />
    </svg>
  );
}

export function WhiteUploadIconComponent() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3337 12.3333L10.0003 9M10.0003 9L6.66699 12.3333M10.0003 9V16.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9919 14.3269C17.8047 13.8838 18.4467 13.1826 18.8168 12.334C19.1868 11.4855 19.2637 10.5379 19.0354 9.64077C18.807 8.74365 18.2865 7.94812 17.5558 7.37973C16.8251 6.81134 15.9259 6.50247 15.0002 6.50186H13.9502C13.698 5.52623 13.2278 4.62047 12.5752 3.85269C11.9225 3.0849 11.1042 2.47507 10.182 2.06903C9.25967 1.663 8.25734 1.47132 7.25031 1.50843C6.24328 1.54553 5.25777 1.81044 4.36786 2.28325C3.47795 2.75605 2.7068 3.42444 2.1124 4.23818C1.51799 5.05191 1.11579 5.9898 0.936028 6.98135C0.756269 7.9729 0.803632 8.9923 1.07456 9.96291C1.34548 10.9335 1.83291 11.8301 2.50021 12.5852"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 12.3333L10.0003 9L6.66699 12.3333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GrayUploadIconComponent() {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3327 11.6654L9.99935 8.33203M9.99935 8.33203L6.66602 11.6654M9.99935 8.33203V15.832"
        stroke="#606062"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9909 13.6589C17.8037 13.2158 18.4458 12.5146 18.8158 11.6661C19.1858 10.8175 19.2627 9.86992 19.0344 8.9728C18.8061 8.07568 18.2855 7.28015 17.5548 6.71176C16.8241 6.14337 15.925 5.8345 14.9992 5.83389H13.9492C13.697 4.85826 13.2269 3.9525 12.5742 3.18472C11.9215 2.41693 11.1033 1.8071 10.181 1.40106C9.2587 0.995027 8.25636 0.803355 7.24933 0.840458C6.2423 0.877561 5.25679 1.14247 4.36688 1.61528C3.47697 2.08808 2.70583 2.75648 2.11142 3.57021C1.51701 4.38394 1.11481 5.32184 0.935051 6.31338C0.755293 7.30493 0.802655 8.32433 1.07358 9.29494C1.3445 10.2655 1.83194 11.1621 2.49923 11.9172"
        stroke="#606062"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3327 11.6654L9.99935 8.33203L6.66602 11.6654"
        stroke="#606062"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GrayThreeDotIconComponent() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="2.16797" r="1.5" fill="#DCE2E3" />
      <circle cx="8" cy="7.16797" r="1.5" fill="#DCE2E3" />
      <circle cx="8" cy="12.168" r="1.5" fill="#DCE2E3" />
    </svg>
  );
}

export function BlueThreeDotIconComponent() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="2.16797" r="1.5" fill="#5DC2FA" />
      <circle cx="8" cy="7.16797" r="1.5" fill="#5DC2FA" />
      <circle cx="8" cy="12.168" r="1.5" fill="#5DC2FA" />
    </svg>
  );
}

export function ClipIconComponent() {
  return (
    <svg
      width="12"
      height="22"
      viewBox="0 0 12 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 16.168V7.16797C11.75 6.75297 11.415 6.41797 11 6.41797C10.585 6.41797 10.25 6.75297 10.25 7.16797V16.168C10.25 18.513 8.345 20.418 6 20.418C3.655 20.418 1.75 18.513 1.75 16.168V4.66797C1.75 3.15297 2.985 1.91797 4.5 1.91797C6.015 1.91797 7.25 3.15297 7.25 4.66797V15.418C7.25 15.7495 7.1183 16.0674 6.88388 16.3019C6.64946 16.5363 6.33152 16.668 6 16.668C5.66848 16.668 5.35054 16.5363 5.11612 16.3019C4.8817 16.0674 4.75 15.7495 4.75 15.418V5.66797C4.75 5.25297 4.415 4.91797 4 4.91797C3.585 4.91797 3.25 5.25297 3.25 5.66797V15.418C3.25 16.933 4.485 18.168 6 18.168C7.515 18.168 8.75 16.933 8.75 15.418V4.66797C8.75 2.32297 6.845 0.417969 4.5 0.417969C2.155 0.417969 0.25 2.32297 0.25 4.66797V16.168C0.25 19.338 2.83 21.918 6 21.918C9.17 21.918 11.75 19.338 11.75 16.168Z"
        fill="#606062"
      />
    </svg>
  );
}

export function WarningIconComponent() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.57514 3.21665L1.51681 15C1.37128 15.252 1.29428 15.5377 1.29346 15.8288C1.29265 16.1198 1.36805 16.4059 1.51216 16.6588C1.65627 16.9116 1.86408 17.1223 2.1149 17.2699C2.36571 17.4174 2.65081 17.4968 2.94181 17.5H17.0585C17.3495 17.4968 17.6346 17.4174 17.8854 17.2699C18.1362 17.1223 18.344 16.9116 18.4881 16.6588C18.6322 16.4059 18.7076 16.1198 18.7068 15.8288C18.706 15.5377 18.629 15.252 18.4835 15L11.4251 3.21665C11.2766 2.97174 11.0674 2.76925 10.8178 2.62872C10.5682 2.48819 10.2866 2.41437 10.0001 2.41437C9.71369 2.41437 9.43208 2.48819 9.18248 2.62872C8.93287 2.76925 8.7237 2.97174 8.57514 3.21665V3.21665Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.5V10.8333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.1667H10.0083"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EmailRow() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.95659 12.4923L5.39831 7.52175L5.75964 6.99992L5.39831 6.47809L1.95659 1.5075L10.2913 1.49992C10.2915 1.49992 10.2916 1.49992 10.2917 1.49992C10.6009 1.50004 10.8744 1.65202 11.0366 1.88188L11.0379 1.88364L14.6674 6.99992L11.0379 12.1162L11.0366 12.118C10.8743 12.3479 10.6007 12.4999 10.2913 12.4999L1.95659 12.4923Z"
        stroke="black"
        stroke-opacity="0.54"
        strokeWidth="1.83333"
      />
    </svg>
  );
}

export function Printer() {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8337 4.66667H3.16699C1.78366 4.66667 0.666992 5.78333 0.666992 7.16667V12.1667H4.00033V15.5H14.0003V12.1667H17.3337V7.16667C17.3337 5.78333 16.217 4.66667 14.8337 4.66667ZM12.3337 13.8333H5.66699V9.66667H12.3337V13.8333ZM14.8337 8C14.3753 8 14.0003 7.625 14.0003 7.16667C14.0003 6.70833 14.3753 6.33333 14.8337 6.33333C15.292 6.33333 15.667 6.70833 15.667 7.16667C15.667 7.625 15.292 8 14.8337 8ZM14.0003 0.5H4.00033V3.83333H14.0003V0.5Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
}

export function NewTabIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8333 13.8333H2.16667V2.16667H8V0.5H2.16667C1.24167 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.24167 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V8H13.8333V13.8333ZM9.66667 0.5V2.16667H12.6583L4.46667 10.3583L5.64167 11.5333L13.8333 3.34167V6.33333H15.5V0.5H9.66667Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
}
